import {
  Box,
  Stack
} from '@mui/material';
import {
  LaborMarketSummaryCard,
  LightDashboardMetricCard,
  TreasuryYieldCurveAreaChart,
  UsGDPBarChart
} from 'modules';

import * as ds from './dataService';



export const FC = () => {
  const { data } = ds.useQuery();

  return (
    <Box
      flex='1 1 0'
      overflow='scroll'
      display='flex'
      flexDirection='column'
      rowGap='1rem'
    >
      <LaborMarketSummaryCard.FC
        data={data.indexMetrics}
        fredCodes={[
          'UNRATE',
          'U6RATE',
          'JTSJOL',
          'PAYEMS',
          'CIVPART',
          'ICSA',
          'CCSA'
        ]}
      />

      <Box>
        <Box
          display='flex'
          flexDirection='row'
          columnGap='1rem'
        >
          {/* LEFT COLUMN */}
          <Stack
            flex='1 1 0'
            direction='column'
            rowGap='1rem'
            overflow='hidden'
          >
            <TreasuryYieldCurveAreaChart.FC />

            <LightDashboardMetricCard.FC
              dataSource='Consumer Health'
              dataLink=''
              data={data.indexMetrics}
              metrics={[
                'PCE',
                'DSPIC96',
                'PSAVERT',
                'UMCSENT',
                'CES0500000003',
                'RSAFS'
              ]}
            />
            <LightDashboardMetricCard.FC
              dataSource='Housing Market'
              dataLink=''
              data={data.indexMetrics}
              metrics={[
                'MORTGAGE30US',
                'HOUST',
                'PERMIT',
                'EXHOSLUSM495S',
                'HPIPONM226S',
                'CSUSHPISA',
                'MARTSSM44W72USS'
              ]}
            />
          </Stack>
          {/* Right column */}
          <Stack
            flex='1 1 0'
            direction='column'
            rowGap='1rem'
            overflow='hidden'
          >
            <UsGDPBarChart.FC />
            <LightDashboardMetricCard.FC
              dataSource='Inflation'
              dataLink=''
              data={data.indexMetrics}
              metrics={[
                'CPIAUCSL',
                'CPILFESL',
                'PCEPI',
                'PCEPILFE',
                'WPSFD4131',
                'WPUFD49207'
              ]}
            />
            <LightDashboardMetricCard.FC
              dataSource='Goods And Services'
              dataLink=''
              data={data.indexMetrics}
              metrics={[
                'ADXTNO',
                'DGORDER',
                'INDPRO',
                'OPHNFB',
                'TCU',
                'WHLSLRIMSA'
              ]}
            />
          </Stack>
        </Box>
      </Box>
    </Box>
  );
};
